import { ReactNode } from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';

function AuthenticatedRoute(props: { children: ReactNode }): JSX.Element {
    const { children } = props;
    const location = useLocation();
    const { accounts } = useMsal();

    return accounts.length > 0 ? (
        <>{children}</>
    ) : (
        <Navigate
            replace={true}
            to="/login"
            state={{ from: `${location.pathname}${location.search}` }}
        />
    );
}

export default AuthenticatedRoute;
